var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferredByPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAXBJREFUOE+tUkFOwlAQffNtCEs8geUGrLUk5SSlO2hMxBPgDaCJAaKLticRk0JccgO4gXVHtPzR+VLShWBN7KZ5+fPezHszhIpfL3JcReyB6e0DOn70lyuhUhV+ELW7UByVa3PNtw/+YlxNIGmvAbahEUIZmRuANxNv0awo4LCwato63wINpfK14ImX0kkB8U2EIRFcITB4Q6AMQAsazxM/dQ8CvcQZKmBgCpliExCxwQAyGCLbhRDrXWfmv2yMQD9uj0rF5aykW1jT1njsz7PryDGTWLBWgg9bCBLnFUBD67wJ1FF4FCxdTm3KTPAfAndf1oc/ddLAXV1bobxtkbfkP/PTeVF7CDFInDEAb/8QMsgmsMHf6csBHAnxmMde5NpK7Z4KIoAVQA3BzJhPu2nnT4ckodZRz95VLqH/fkjFZEHiyCYumElsmvsQW9Oqp9yPrgakaFS2qrX2Z/4yrmTBrDq6bAGqy+DGGSi+32/iE/EJtBGqf6n0AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferredByPic);
export default __webpack_public_path__ + "static/media/referredBy_pic.d4b9ba5e42d65d2534953d0f36cf6686.svg";
export { ForwardRef as ReactComponent };